import ProfilDetailController from './profil.detail.controller';

export default {
    template: require('./profil.detail.tpl.html'),
    controller: ProfilDetailController
};
